import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBookComponent } from "./med-icon-book.component";

@NgModule({
  declarations: [
    MedIconBookComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBookComponent,
  ],
})
export class MedIconBookModule { }
